export default __webpack_public_path__ + "static/media/Cormark.6b550567.png";